<template>
  <transition>
    <div
      v-if="filterToggle"
      class="pt-2"
    >
      <b-form
        class="border-dashed"
      >
        <b-row>
          <b-col md="4">
            <b-form-group
              :label="$t(filterClass.getLabel(AllExams.DC_TYPE))"
              :label-for="AllExams.DC_TYPE"
            >
              <v-select
                :id="AllExams.DC_TYPE"
                v-model="filters[AllExams.DC_TYPE]"
                multiple
                :reduce="(option) => option.id"
                :options="dcTypes"
                :get-option-label="(option) => $langName(option.name)"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col
            v-if="universityList.length > 1"
            md="4"
          >
            <b-form-group
              :label="$t('Education organizations')"
              :label-for="AllExams.ORGANIZATION"
            >
              <v-select
                :id="AllExams.ORGANIZATION"
                v-model="filters[AllExams.ORGANIZATION]"
                :reduce="(option) => option.id"
                :options="universityList"
                :get-option-label="(option) => $langName(option.name)"
                :placeholder="$t('All')"
                @input="selectDirections"
              />
            </b-form-group>
          </b-col>
          <b-col
            v-if="directions.length"
            md="4"
          >
            <b-form-group
              :label="$t(filterClass.getLabel(AllExams.DIRECTION))"
              :label-for="AllExams.DIRECTION"
            >
              <v-select
                :id="AllExams.DIRECTION"
                v-model="filters[AllExams.DIRECTION]"
                :reduce="(option) => option.id"
                :options="directions"
                :get-option-label="(option) => option.code + ' - ' + $langName(option.name)"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="4"
          >
            <b-form-group
              v-if="periods.length > 0"
              :label="$t(filterClass.getLabel(AllExams.PERIOD))"
              :label-for="AllExams.PERIOD"
            >
              <v-select
                id="period"
                v-model="filters[AllExams.PERIOD]"
                :options="periods"
                :get-option-label="(option) => option.admission_year + '-' + option.name"
                :placeholder="$t('All')"
                @input="selectQuarter"
              />
            </b-form-group>
          </b-col>
          <b-col
            v-if="filters[AllExams.PERIOD]"
            md="4"
          >
            <b-form-group
              :label="$t(filterClass.getLabel(AllExams.QUARTER))"
              :label-for="AllExams.QUARTER"
            >
              <v-select
                :id="AllExams.QUARTER"
                v-model="filters[AllExams.QUARTER]"
                :reduce="(option) => option.id"
                :options="filters[AllExams.PERIOD].quarters"
                :get-option-label="(option) => option.quarter"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              :label="$t(filterClass.getLabel(AllExams.IS_CERTIFICATE))"
              :label-for="AllExams.IS_CERTIFICATE"
            >
              <v-select
                :id="AllExams.IS_CERTIFICATE"
                v-model="filters[AllExams.IS_CERTIFICATE]"
                :reduce="(option) => option.id"
                :options="yesNoOptions"
                label="name"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              :label="$t(filterClass.getLabel(AllExams.IS_ACCEPTED))"
              :label-for="AllExams.IS_ACCEPTED"
            >
              <v-select
                :id="AllExams.IS_ACCEPTED"
                v-model="filters[AllExams.IS_ACCEPTED]"
                :reduce="(option) => option.id"
                :options="examResultStatuses"
                :get-option-label="(option) => $langName(option.name)"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-button
              class="mr-1"
              variant="success"
              @click="onFilter"
            >
              <feather-icon icon="LFilterIcon" />
              {{ $t('Filter') }}
            </b-button>

            <excel
              :payload="filterClass.convertToQuery(filters)"
              dispatch-action="allExams/excel"
            />
          </b-col>
        </b-row>
      </b-form>
    </div>
  </transition>
</template>

<script>
import vSelect from 'vue-select'
import {
  BRow, BCol, BFormGroup, BButton, BForm,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { isObject } from '@core/utils/utils'
import AllExams from '@/views/components/filters/service/AllExams'
import Excel from '@/views/pages/all-exams/components/Excel.vue'

export default {
  name: 'FilterComponent',
  components: {
    BForm,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BButton,
    Excel,
  },
  directives: {
    Ripple,
  },
  props: {
    filterToggle: {
      type: Boolean,
      required: true,
    },
    filters: {
      type: [Array, Object],
      default: () => ({}),
    },
    filterClass: {
      type: [Object, null],
      default: null,
    },
    selectedFilters: {
      type: [Array],
      default: () => ([]),
    },
  },
  data() {
    return {
      period: null,
      yesNoOptions: [
        { id: true, name: this.$t('Yes') },
        { id: false, name: this.$t('No') },
      ],
    }
  },
  computed: {
    AllExams() {
      return AllExams
    },
    dcTypes() {
      return this.$store.state.staticModule.dcTypes
    },
    applyDocumentStatuses() {
      return this.$store.state.staticModule.applyDocumentStatuses
    },
    universityList() {
      return this.$store.state.staticModule.universityList
    },
    directions() {
      return this.$store.state.staticModule.directionList
    },
    periods() {
      return this.$store.state.period.periods
    },
    examResultStatuses() {
      return this.$store.state.staticModule.examResultStatuses
    },
  },
  watch: {
    universityList(newValue) {
      this.changeValue(newValue, AllExams.ORGANIZATION)
    },
    periods(newValue) {
      this.changeValue(newValue, AllExams.PERIOD)
      if (this.filters[AllExams.PERIOD]?.quarters) this.changeValue(this.filters[AllExams.PERIOD].quarters, AllExams.QUARTER)
    },
    directions(newValue) {
      this.changeValue(newValue, AllExams.DIRECTION)
    },
  },
  created() {
    this.changeValue(this.applyDocumentStatuses, AllExams.STATUS)
    this.changeValue(this.yesNoOptions, AllExams.IS_CERTIFICATE)
    this.changeValue(this.yesNoOptions, AllExams.IS_ACCEPTED)
    if (Array.isArray(this.filters[AllExams.DC_TYPE])) {
      this.filters[AllExams.DC_TYPE] = this.filters[AllExams.DC_TYPE].map(x => Number(x))
    } else if (this.filters[AllExams.DC_TYPE]) {
      this.filters[AllExams.DC_TYPE] = [Number(this.filters[AllExams.DC_TYPE])]
    }
    if (this.filters[AllExams.ORGANIZATION]) {
      this.selectDirections(this.filters[AllExams.ORGANIZATION])
    }
  },
  methods: {
    selectDirections(id) {
      if (id) {
        this.$store.dispatch('staticModule/directionList', { org_id: id })
      } else {
        this.$store.commit('staticModule/SET_DIRECTION_LIST', [])
      }
    },
    selectQuarter() {
      this.filters[AllExams.QUARTER] = null
    },
    onFilter() {
      this.$emit('onFilter', this.filter)
    },
    changeValue(newValue, field) {
      if (newValue.length && !isObject(this.filters[field])) {
        this.filters[field] = newValue.find(x => `${x.id}` === this.filters[field])
      }
    },
  },
}
</script>

<style scoped>

</style>
